import { useContext } from "react";
import toast from "react-hot-toast";
import Modal from "react-modal";
import { AppContext } from "../../scripts/context";
import { customStyles, ModalContentStyle } from "./style";
import WalletConnectProvider from "@walletconnect/web3-provider";
import QRCodeModal from "@walletconnect/qrcode-modal";

export default function ConnectWalletModal({
  connectWalletModal,
  setConnectWalletModal,
}) {
  const { state, getWeb3, setState, initState } = useContext(AppContext);

  const connectMetaMask = async () => {
    closeModal();

    if (!window.ethereum) {
      toast.error("MetaMask is not installed");

      return;
    }

    try {
      setState({ loading: true });

      const address = await window.ethereum.request({
        method: "eth_requestAccounts",
      });
      getWeb3(address[0]);
    } catch (error) {
      setState({ loading: false });
      console.log(error);
    }
  };

  const connectWalletConnect = async () => {
    closeModal();

    const provider = new WalletConnectProvider({
      qrcodeModal: QRCodeModal,
      qrcode: true,
      rpc: {
        [process.env.REACT_APP_CHAIN_ID]: process.env.REACT_APP_CHAIN_RPC_URL,
      },
      bridge: "https://bridge.walletconnect.org",
      qrcodeModalOptions: {
        desktopLinks: ["metamask"],
      },
    });

    await provider.enable();
    if (provider.chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
      setState({
        loading: false,
        netWork: {
          ...state.netWork,
          chainId: provider.chainId,
        },
      });
      await provider.disconnect();

      toast.error("Wrong network");
      return;
    }

    setState({ loading: true });
    getWeb3(provider.accounts[0], provider);
    localStorage.connectStatus = 2;

    provider.on("accountsChanged", (accounts) => {
      if (state.user.address !== accounts[0]) {
        setState({ loading: true });
        getWeb3(accounts[0], provider);
      }
    });

    provider.on("chainChanged", async (chainId) => {
      if (chainId !== Number(process.env.REACT_APP_CHAIN_ID)) {
        await provider.disconnect();
      }
    });

    provider.on("disconnect", () => {
      setState({
        ...initState,
        loading: false,
      });
      localStorage.connectStatus = 0;
    });
  };
  const closeModal = () => setConnectWalletModal(false);

  return (
    <Modal
      isOpen={connectWalletModal}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel="connect wallet modal"
      closeTimeoutMS={20}
      className="ConnectWalletModal"
    >
      <ModalContentStyle>
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            Connect Using ..
          </h5>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            style={{
              background: "transparent",
              border: "none",
              padding: 0,
              fontSize: "2rem",
              width: "36px",
            }}
            onClick={() => setConnectWalletModal(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="connect-wallet-modal-body">
          <button className="metamask" onClick={connectMetaMask}>
            <img src="/img/metamask.webp" alt="commission-rate" />
            <span>MetaMask</span>
          </button>
          <button className="wallet-connect" onClick={connectWalletConnect}>
            <img src="/img/walletconnect.png" alt="commission-rate" />
            <span>WalletConnect</span>
          </button>
        </div>
      </ModalContentStyle>
    </Modal>
  );
}
